import { ArrowUpRight, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../data/site";

const GoogleG = () => (
  <svg viewBox="0 0 24 24" className="h-8 w-8" aria-label="Google">
    <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.7-.2-2.5H12v4.8h6.5c-.3 1.6-1.2 2.9-2.5 3.8v3.1h4c2.4-2.2 3.5-5.4 3.5-9.2z" />
    <path fill="#34A853" d="M12 24c3.2 0 6-1.1 7.9-2.9l-4-3.1c-1.1.7-2.5 1.2-3.9 1.2-3 0-5.6-2-6.5-4.8H1.4v3.2C3.3 21.3 7.3 24 12 24z" />
    <path fill="#FBBC05" d="M5.5 14.4c-.2-.7-.4-1.5-.4-2.4s.1-1.7.4-2.4V6.4H1.4C.5 8.3 0 10.1 0 12s.5 3.7 1.4 5.6l4.1-3.2z" />
    <path fill="#EA4335" d="M12 4.8c1.8 0 3.3.6 4.6 1.8l3.5-3.5C18 1.2 15.2 0 12 0 7.3 0 3.3 2.7 1.4 6.4l4.1 3.2c.9-2.7 3.5-4.8 6.5-4.8z" />
  </svg>
);

export const GoogleRating = () => (
  <section data-testid="google-rating-section" className="py-16 sm:py-24">
    <div className="mx-auto max-w-5xl px-4 sm:px-8">
      <Reveal>
        <div className="img-spotlight relative flex flex-col items-center gap-10 overflow-hidden border border-brand/25 bg-white p-10 sm:p-14 md:flex-row md:justify-between">
          <span className="absolute left-0 top-0 h-px w-full shimmer-line" />
          <div className="flex items-center gap-8">
            <GoogleG />
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#8B8577]">
                Google Business Rating
              </p>
              <div className="mt-2 flex items-end gap-4">
                <span className="font-serif text-6xl font-medium leading-none text-foreground" data-testid="google-rating-value">
                  4.9
                </span>
                <div className="flex gap-1 pb-1.5 text-[#FBBC05]">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={20} fill="currentColor" />
                  ))}
                </div>
              </div>
              <p className="mt-3 text-sm text-[#5C6570]">
                Rated by customers on Google Maps · Tigaon Road, Sector 86
              </p>
            </div>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row md:w-auto md:flex-col">
            <a
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-read-reviews-button"
              className="group flex items-center justify-center gap-2 bg-brand px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-brand-bright"
            >
              Read Reviews <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
            <a
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-write-review-button"
              className="flex items-center justify-center gap-2 border border-ink/20 px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-ink transition-all duration-300 hover:border-brand hover:text-brand"
            >
              Write a Review
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
